'use strict';
import './slider.less'
//
import React from 'react';
import {extend} from 'jquery';
import classnames from 'classnames'
//

import Component from '../core/component';
import Enhance from '../core/enhance';
//
import tools from '../libs/tools';
import device from '../libs/device'
import debug from 'debug';


const log = debug('common.slider');

let isTouchPad = (/hp-tablet/gi).test(navigator.appVersion);
let hasTouch = 'ontouchstart' in window && !isTouchPad;

if ((/wechatdevtools/gi).test(navigator.appVersion)) {
    hasTouch = true;
}
if (device.mobile) {
    hasTouch = true;
}

let touchStart = hasTouch ? 'touchstart' : 'mousedown';
let touchMove = hasTouch ? 'touchmove' : 'mousemove';
let touchEnd = hasTouch ? 'touchend' : 'mouseup';
// let cache = {};
// let animationEnd = 'animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd';


// console.log('isTouchPad => ' + isTouchPad);
// console.log('hasTouch => ' + hasTouch);
// console.log('touchStart => ' + touchStart);
// console.log('touchMove => ' + touchMove);
// console.log('touchEnd => ' + touchEnd);

/**
 * 轮播
 */
class Slider extends Component {
    eventNames = ["Slider"];

    state = {
        delayTime: 300,
        startX: 0,
        startY: 0,
        distX: 0,
        distY: 0,
        dist: 0, //手指滑动距离
        autoPlay: false,
        autoPlayTime: 5000,
        x: 0,
        y: 0,
        lastX: 0,
        lastY: 0,
        timer: null,
        items: [],
        length: 0,
        current: 0,
        views: [],
        // moveTag: 0,
        moving: false
    };

    constructor(props) {
        super(props);
        extend(this.state, props);

        this.state.autoPlayTime = this.props.autoPlayTime || 5000;
        this.state.autoPlay = this.props.autoPlay || false;
        this.state.delayTime = this.props.delayTime || 300;

        this.state.views[-1] = this.renderItem(0, -1);
        this.state.views[0] = this.renderItem(0, 0);
        this.state.views[1] = this.renderItem(0, 1);

    }

    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        //添加“触摸移动”事件监听
        hasTouch && this.refs.slider.addEventListener(touchStart, this.handlerTouchStart, false);
        this.handlerAutoPlay();
        this.refs.SliderHigh.setLength(this.state.length);
    }


    /**
     * 输入参数 nextProps 是即将被设置的属性，
     * 旧的属性还是可以通过 this.props 来获取。
     * 在这个回调函数里面，你可以根据属性的变化，
     * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
     * 并不会触发额外的 render() 调用
     */
    componentWillReceiveProps(nextProps) {
        extend(this.state, nextProps);
        this.refs.SliderHigh.setLength(this.state.length);
        if (this.props.length !== nextProps.length) {
            this.refresh(0);
        }
        // this.handlerUpdateState();
    }

    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {
        clearTimeout(this.state.timer);
    }

    /**
     * componentDidUpdate(object prevProps, object prevState)在更新发生之后调用。
     */
    componentDidUpdate(prevProps, prevState) {
    }

    /**
     *
     * @returns {XML}
     */
    render() {
        return (
            <div className={classnames('c-slider', this.props.className)} style={this.props.style}>
                <SliderHigh ref="SliderHigh"/>
                <div style={{height: '100%', width: '100%', overflow: 'hidden'}}>
                    <div ref="slider" className="c-slider-block">
                        {this.renderInnerView()}
                    </div>
                </div>
            </div>
        );
    }

    /**
     *
     * @param data
     */
    move(data) {
        if (tools.is_int(data.x)) {
            this.refresh(data.x, () => {
                this.state.x += data.x;
                this.handlerDoPlay();
            })
        }
    }

    /**
     *
     * @param index
     * @param callback
     */
    refresh(index = 0, callback) {
        let tag = 0;
        if (index > 0) {
            tag = 1
        } else if (index < 0) {
            tag = -1
        }
        this.state.views[tag] = this.renderItem(this.state.x + index, 0);
        this.forceUpdate(() => {
            callback && callback();
        })
    }


    /**
     *
     * @return {*[]}
     */
    renderInnerView() {
        return [
            <div key={this.state.x - 1} className="c-slider-inner"
                 style={this.handlerTranslate3d("-100%", 0, 0)}>
                {this.state.views[-1]}
            </div>,
            <div key={this.state.x} className="c-slider-inner"
                 style={this.handlerTranslate3d(0, 0, 0)}>
                {this.state.views[0]}
            </div>,
            <div key={this.state.x + 1} className="c-slider-inner"
                 style={this.handlerTranslate3d("100%", 0, 0)}>
                {this.state.views[1]}
            </div>
        ];
    }

    /**
     *
     * @param sel
     * @returns {*}
     * @private
     */
    renderItem(x, index) {
        let xIndex = x + index;

        let item = null;
        if (this.props.Adapter) {
            item = this.props.Adapter(xIndex, x);
        }
        if (!item && this.props.items) {
            item = this.props.items[Math.abs(xIndex) % this.props.items.length];
        }

        return item;
    }


    /**
     * 开启自动播放
     * @private
     */
    handlerAutoPlay = () => {
        if (this.state.autoPlay)
            this.state.timer = setInterval(() => {
                this.state.x++;
                this.handlerDoPlay();
            }, this.state.autoPlayTime);
    }

    /**
     *
     * @private
     */
    handlerDoPlay = () => {
        let i = 1;
        if (this.state.lastX == this.state.x)
            return;

        if (this.state.lastX < this.state.x)
            i = -1;
        this.handlerTranslate((i * 100) + "%", this.state.delayTime);
        this.endTimeout = setTimeout(this.handlerUpdateState, this.state.delayTime);
    }

    /**
     * 执行完成之后更新状态
     * @private
     */
    handlerUpdateState = () => {
        //通知
        this.props.onChange && this.props.onChange({x: this.state.x, y: this.state.y});
        this.state.lastX = this.state.x;

        //刷新内部组件
        this.state.views[-1] = this.renderItem(this.state.x, -1);
        this.state.views[0] = this.renderItem(this.state.x, 0);
        this.state.views[1] = this.renderItem(this.state.x, 1);

        this.handlerTranslate(0, 0);

        let idx = this.state.lastX % this.state.length;
        if (idx < 0)
            idx = this.state.length + idx;

        this.refs.SliderHigh.setIndex(idx);

        //更新
        this.forceUpdate(() => {
            this.state.moving = false;
        });
    }

    /**
     * android版的微信使用setState更新UI时部分机型会出现卡顿效果
     * @param e
     */
    handlerTouchStart = (e) => {

        if (this.state.moving)
            return;

        //添加“触摸移动”事件监听
        this.refs.slider.addEventListener(touchMove, this.handlerTouchMove, false);
        //添加“触摸结束”事件监听
        this.refs.slider.addEventListener(touchEnd, this.handlerTouchEnd, false);

        clearInterval(this.state.timer);
        this.state.distX = 0;
        this.state.distY = 0;
        let point = hasTouch ? e.touches[0] : e;
        this.state.startX = point.pageX;
        this.state.startY = point.pageY;
    }

    /**
     * 滑动事件
     * @param e
     * @private
     */
    handlerTouchMove = (e) => {
        if (hasTouch) {
            //多点或缩放
            if (e.touches.length > 1 || e.scale && e.scale !== 1) return
        }

        let point = hasTouch ? e.touches[0] : e;
        this.state.distX = point.pageX - this.state.startX;
        this.state.distY = point.pageY - this.state.startY;
        let slideW = this.getSlideWidth();

        let _3dx = 0;

        if (this.state.distX > 10 || this.state.distX < -10) {
            this.state.moving = true;
            _3dx = (this.state.distX / slideW) * 100;
        }
        this.handlerTranslate(_3dx + '%');
    }

    /**
     * 滑动结束
     * @param e
     * @private
     */
    handlerTouchEnd = (e) => {
        this.refs.slider.removeEventListener(touchMove, this.handlerTouchMove, false);
        this.refs.slider.removeEventListener(touchEnd, this.handlerTouchEnd, false);

        if (Math.abs(this.state.distX) > this.getSlideWidth() * 0.1) {
            this.state.distX > 0 ? this.state.x-- : this.state.x++;
            this.handlerTranslate(this.state.distX > 0 ? '100%' : '-100%', this.state.delayTime);
            this.endTimeout = setTimeout(this.handlerUpdateState, this.state.delayTime + 50);
        } else {
            this.handlerTranslate(0, this.state.delayTime);
            this.endTimeout = setTimeout(this.handlerUpdateState, this.state.delayTime + 50);
        }
        this.handlerAutoPlay();
    }

    /**
     * 移动中
     * @param x
     * @param speed
     */
    handlerTranslate(x, speed = 0) {
        let ele = this.refs.slider.style;
        ele.webkitTransitionDuration = ele.MozTransitionDuration = ele.msTransitionDuration = ele.OTransitionDuration = ele.transitionDuration = speed + 'ms';
        ele.webkitTransform = 'translate3d(' + (x) + ',0,0)';
        ele.msTransform = ele.MozTransform = ele.OTransform = 'translate3d(' + (x) + ',0,0)';
    }

    /**
     * 获取slide的宽度
     * @returns {*|number}
     * @private
     */
    getSlideWidth = () => {
        return this.refs.slider.clientWidth;
    }


    /**
     *
     * @param x
     * @param y
     * @param z
     * @returns {{transform: string}}
     * @private
     */
    handlerTranslate3d(x = '0%', y = '0%', z = '0%') {
        return {
            'transform': `translate3d(${x}, ${y}, ${z})`
        }
    }

    /**
     *
     * @param length
     * @param current
     */
    setHigh = (length, current) => {
        this.refs.SliderHigh.setHigh(length, current);
    }

}

/**
 *
 */

class SliderHigh extends Component {
    state = {
        length: 0,
        current: 0
    }

    render() {
        return this.state.length > 0 ? (
            <div className="c-slider-high">
                {this.renderViews()}
            </div>
        ) : null;
    }

    renderViews() {
        let views = [];
        for (let i = 0; i < this.state.length; i++) {
            views.push(<a key={i} className={classnames({current: this.state.current == i})}><b></b></a>)
        }
        return views;
    }

    /**
     *
     * @param length
     * @param current
     */
    setLength(length) {
        this.setState({length});
    }

    /**
     *
     * @param current
     */
    setIndex(current) {
        this.setState({current});
    }


    get x() {
        return this.state.x;
    }

    get y() {
        return this.state.y
    }


}

Enhance(SliderHigh);
Enhance(Slider, {}, 'Slider');
export default Slider;
